module.exports = __webpack_public_path__ + "img/bg-opciones.60995596.png";